import { render } from "./Search2.vue?vue&type=template&id=03b57fbd&scoped=true"
import script from "./Search2.vue?vue&type=script&lang=js"
export * from "./Search2.vue?vue&type=script&lang=js"

import "./Search2.vue?vue&type=style&index=0&id=03b57fbd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b57fbd"]])

export default __exports__